const defaultTranslations = {
  this_placement_is_already_linked_to_orders: 'This placement is already linked to orders:',
  you_can_use_it_on_other_dates: 'You can use it on other dates.',
  no_matches_found: 'No matches found',
  you_cannot_select_this_item: 'You cannot select this item.',
  go_to_page: 'Go to page',
  show_per_page: 'Show per page',
  show_x_to_y_of_z: 'Show {0} - {1} of {2}',
  pagination_no_items: 'No items',
  search: 'Search',
  reset: 'Reset',
  reset_all: 'Reset all',
  select_all: 'Select all',
  items_chosen_format: 'Items chosen: {0}',
  apply: 'Apply',
  cancel: 'Cancel',
  create_new_option: 'Create new',
  table_settings: 'Table settings',
  column_presets: 'Column presets',
  edit_table_preset: 'Editing of preset',
  no_table_presets_found: 'You have not created any templates yet',
  default_settings: 'Default settings',
  selected_columns: 'Selected columns ({0})',
  save_as_preset: 'Save as preset',
  select: 'Select',
  all: 'All',
  all_time: 'All time',
  yesterday: 'Yesterday',
  this_week: 'This week',
  last_week: 'Last week',
  this_month: 'This month',
  last_month: 'Last month',
  last_x_day: 'Last {0} day',
  last_x_days: 'Last {0} days',
  start_date: 'Start date',
  end_date: 'End date'
};

export default defaultTranslations;
